
import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import '@angular/localize/init';
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

import { ManualClaimProfile } from '@app/models/manual-claim-profile.model';
import { RegularExpressions } from '@app/services/regular-expressions';
import { RankipediaService } from '@app/services/rankipedia.service';
import { AlertService, MessageSeverity } from '@app/services/alert.service';
import { isNullOrUndefined } from 'util';

@Component({
  selector: 'app-manual-claim-profile-dialog',
  templateUrl: './manual-claim-profile-dialog.component.html',
  styleUrls: ['./manual-claim-profile-dialog.component.scss']
})

export class ManualClaimProfileDialogComponent implements OnInit {
  isLoading = false;
  manualClaimModel: ManualClaimProfile = new ManualClaimProfile();
  form: FormGroup = new FormGroup({});
  @Input() additionalMessage: string = null;
  @Output() closeEvent: EventEmitter<any> = new EventEmitter();

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private _alertService: AlertService,
    private _rankiService: RankipediaService  ) {
  }

  ngOnInit(): void {
    this.initForm();
  }
  
  private initForm() {
    this.form = new FormGroup({
      firstName: new FormControl(this.manualClaimModel ? this.manualClaimModel.firstName : null, { validators: [Validators.required, Validators.maxLength(100), Validators.pattern(RegularExpressions.Name)], updateOn: 'blur' }),
      lastName: new FormControl(this.manualClaimModel ? this.manualClaimModel.lastName : null, { validators: [Validators.required, Validators.maxLength(100), Validators.pattern(RegularExpressions.Name)], updateOn: 'blur' }),
      phone: new FormControl(this.manualClaimModel ? this.manualClaimModel.phone : null, { validators: [Validators.required, Validators.maxLength(15), Validators.pattern(RegularExpressions.Phone)], updateOn: 'blur' }),
      website: new FormControl(this.manualClaimModel ? this.manualClaimModel.website : null, { validators: [Validators.maxLength(200), Validators.pattern(RegularExpressions.Website)], updateOn: 'blur' }),
      email: new FormControl(this.manualClaimModel ? this.manualClaimModel.email : null, { validators: [Validators.required, Validators.maxLength(60), Validators.pattern(RegularExpressions.Email)], updateOn: 'blur' }),
      message: new FormControl(this.manualClaimModel ? this.manualClaimModel.message : null, { validators: [Validators.maxLength(1000)], updateOn: 'blur' })
    }, {});
  }

  submitRequest() {
    this.isLoading = true;
    this.manualClaimModel.firstName = this.form.value.firstName;
    this.manualClaimModel.lastName = this.form.value.lastName;
    this.manualClaimModel.phone = this.form.value.phone;
    this.manualClaimModel.website = this.form.value.website;
    this.manualClaimModel.email = this.form.value.email;
    this.manualClaimModel.message = this.form.value.message;
    if (!isNullOrUndefined(this.additionalMessage)){
      this.manualClaimModel.message = `${this.manualClaimModel.message} [system added: ${this.additionalMessage}]`;
    }
    return this._rankiService.manualClaimProfile(this.manualClaimModel).subscribe(res => {
      if (res != null) {
         this._alertService.showMessage("Claim Request Sent", res.Data, MessageSeverity.success);
         this.router.navigate(['/claim/manualcomplete']);
      }
      this.isLoading = false;
      this.close(true);
      return true;
    }),
      catchError(err => {
        console.log(err);
        this.isLoading = false;
        this._alertService.showMessage("Manual Claim Profile", `We're sorry there was an error sending your message. ${err}`, MessageSeverity.error);
        this.close(false);
        return of<any>([]);
      });
    return false;
  }
  
  firstNameInvalid() {
    return (!this.form.controls.firstName.valid)
  }

  lastNameInvalid() {
    return (!this.form.controls.lastName.valid)
  }

  phoneInvalid() {
    return (!this.form.controls.phone.valid)
  }

  websiteInvalid() {
    return (this.form.controls.website.touched && !this.form.controls.website.valid)
  }

  emailInvalid() {
    return (!this.form.controls.email.valid)
  }

  messageInvalid() {
    return (this.form.controls.message.touched && !this.form.controls.message.valid)
  }

  formIsValid() {
    const isValid = this.form.valid;
    return isValid;
  }

  close(value) {
    setTimeout(() => {
      this.closeEvent.emit(value);
    }, 100);
  }
}
